import React from 'react';
import iconClose from '../../style/icons/cancel.svg';
import iconConfirm from '../../style/icons/check.svg';

// A single reservation card (clean 2026). Prop-driven so real data can wire in later.
const Riboahp = ({ time = '18:30', table = '401', area = 'בר מלצרים', size = '7P', name = 'יובל בן שאול', onCancel, onConfirm }) => (
    <div className="hp-card">
        <div className="hp-card-top">
            <span className="hp-card-time" dir="ltr">{time}</span>
            {onCancel && <button className="hp-card-x" aria-label="ביטול" onClick={onCancel}><img src={iconClose} alt="" /></button>}
        </div>
        <div className="hp-card-mid">
            <div className="hp-card-table">{table}</div>
            <div className="hp-card-area">{area}</div>
        </div>
        <div className="hp-card-foot">
            <span className="hp-card-size" dir="ltr">{size}</span>
            <span className="hp-card-name">{name}</span>
            {onConfirm && <button className="hp-card-ok" aria-label="אישור" onClick={onConfirm}><img src={iconConfirm} alt="" /></button>}
        </div>
    </div>
);

export default Riboahp;
